import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { companyInfo } from '../data/mock';

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {/* Hero Banner */}
        <div className="relative h-[250px] bg-[#FFDA00]">
          <img
            src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&h=400&fit=crop"
            alt="Australian farmland"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white">About Us</h1>
          </div>
        </div>

        {/* Content */}
        <section className="py-12 px-4 bg-[#f5f5f0]">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold text-[#FFDA00] mb-6">
                Who We Are
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>{companyInfo.description.intro}</p>
                <p>{companyInfo.description.model}</p>
              </div>

              <h3 className="text-xl font-bold text-[#FFDA00] mt-8 mb-4">
                Our Export Operations
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {companyInfo.description.exports}
              </p>

              <h3 className="text-xl font-bold text-[#FFDA00] mt-8 mb-4">
                Our Values
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {companyInfo.description.values}
              </p>

              {/* Key Points */}
              <div className="mt-8 grid md:grid-cols-3 gap-4">
                <div className="bg-[#FFDA00]/10 rounded-lg p-6 text-center">
                  <div className="text-3xl font-bold text-[#FFDA00] mb-2">15</div>
                  <div className="text-gray-600">Years Experience</div>
                </div>
                <div className="bg-[#FFDA00]/10 rounded-lg p-6 text-center">
                  <div className="text-3xl font-bold text-[#FFDA00] mb-2">50+</div>
                  <div className="text-gray-600">Partner Farmers</div>
                </div>
                <div className="bg-[#FFDA00]/10 rounded-lg p-6 text-center">
                  <div className="text-3xl font-bold text-[#FFDA00] mb-2">20+</div>
                  <div className="text-gray-600">Export Destinations</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
